import { useQueryClient } from 'react-query';

import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteEmailFilter = () => {
  const queryClient = useQueryClient();
  return useDelete({
    url: ApiRoutesEnum.emailsDeleteFilter,
    onSuccess: () => {
      queryClient.invalidateQueries([ApiRoutesEnum.emailsFilters]);
    },
  });
};
